// Webshop Filters Enhancement - Optimized
(function() {
    'use strict';

    // Console-hygiene (ERP-161): gate verbose [WebshopFilters] chatter behind a single
    // opt-in debug flag — localStorage 'csl_debug' === '1', default OFF. Logs are
    // preserved (not deleted); console.error stays unconditional so real errors remain
    // visible in production. Enable in DevTools: localStorage.setItem('csl_debug','1').
    var CSL_DEBUG = (function () { try { return localStorage.getItem('csl_debug') === '1'; } catch (e) { return false; } })();
    function cslLog() { if (CSL_DEBUG) { console.log.apply(console, arguments); } }

    let collapsedFilters = new Set();

    // Debounce utility to prevent excessive function calls
    function debounce(func, wait) {
        let timeout;
        return function executedFunction(...args) {
            const later = () => {
                clearTimeout(timeout);
                func(...args);
            };
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
        };
    }

    $(document).ready(function() {
        cslLog('[WebshopFilters] Initializing...');

        // Initialize all components with single timeout
        setTimeout(function() {
            initCollapsibleFilters();
            applyCompactSpacing();
            hideSearchBoxes();
        }, 500);

        setupFilterInterceptor();
    });

    function setupFilterInterceptor() {
        cslLog('[WebshopFilters] Setting up interceptor');

        const originalOpen = XMLHttpRequest.prototype.open;
        const originalSend = XMLHttpRequest.prototype.send;

        XMLHttpRequest.prototype.open = function(method, url) {
            this._url = url;
            return originalOpen.apply(this, arguments);
        };

        XMLHttpRequest.prototype.send = function(body) {
            const xhr = this;

            // Only intercept filter data requests
            if (body && typeof body === 'string' && body.includes('get_product_filter_data')) {
                xhr.addEventListener('load', function() {
                    if (xhr.status === 200) {
                        try {
                            const response = JSON.parse(xhr.responseText);
                            if (response.message && response.message.filter_data) {
                                cslLog('[WebshopFilters] Intercepted filter response');
                                // Debounced update
                                debouncedUpdateFilterVisibility(response.message.filter_data);
                            }
                        } catch (e) {
                            console.error('[WebshopFilters] Parse error:', e);
                        }
                    }
                });
            }

            return originalSend.apply(this, arguments);
        };

        cslLog('[WebshopFilters] Interceptor ready');
    }

    // Debounced version to prevent excessive updates
    const debouncedUpdateFilterVisibility = debounce(updateFilterVisibility, 150);

    function updateFilterVisibility(filterData) {
        cslLog('[WebshopFilters] updateFilterVisibility called');

        // Build maps for both field filters and attribute filters
        var availableValues = {};
        filterData.forEach(function(filter) {
            var key = filter.filter_name.toLowerCase();
            availableValues[key] = filter.values.map(function(v) { return v.value; });
        });

        cslLog('[WebshopFilters] Available filters:', availableValues);

        $('.filter-block').each(function() {
            var block = $(this);
            var firstCheckbox = block.find('input[type="checkbox"]').first();

            // Get filter name - could be data-filter-name (field) or data-attribute-name (attribute)
            var filterName = firstCheckbox.attr('data-filter-name');
            var attributeName = firstCheckbox.attr('data-attribute-name');

            // Determine the key to use
            var key = filterName || (attributeName ? attributeName.toLowerCase() : null);
            var isAttribute = !filterName && attributeName;

            cslLog('[WebshopFilters] Processing block - filterName:', filterName, 'attributeName:', attributeName, 'key:', key, 'isAttribute:', isAttribute);

            if (!key) {
                cslLog('[WebshopFilters] No key found for block, hiding');
                block.hide();
                return;
            }

            var available = availableValues[key];

            // If filter is not in response at all, hide the entire block
            if (available === undefined || available.length === 0) {
                cslLog('[WebshopFilters] Hiding entire block:', key);
                block.hide();
                return;
            }

            // Show the block
            block.show();
            cslLog('[WebshopFilters] Filter', key, 'available values:', available);

            // Find all checkboxes in this block and hide/show individual options
            block.find('input[type="checkbox"]').each(function() {
                var checkbox = $(this);
                // For field filters use data-filter-value, for attribute filters use data-attribute-value
                var value = isAttribute ? checkbox.attr('data-attribute-value') : checkbox.attr('data-filter-value');
                var item = checkbox.closest('.filter-item, .checkbox, div').first();

                if (available.includes(value)) {
                    item.show().css('opacity', '1');
                } else {
                    // Hide unavailable options, but keep checked ones visible (dimmed)
                    if (checkbox.is(':checked')) {
                        item.show().css('opacity', '0.5');
                    } else {
                        item.hide();
                    }
                }
            });
        });

        updateActiveFilterIndicators();
    }

    function initCollapsibleFilters() {
        cslLog('[WebshopFilters] initCollapsibleFilters called');

        $('.filter-block').each(function() {
            var block = $(this);

            if (block.data('collapsible-init')) {
                return;
            }
            block.data('collapsible-init', true);

            var label = block.find('.filter-label').first();
            if (!label.length) return;

            var firstCheckbox = block.find('input[type="checkbox"]').first();
            var filterName = firstCheckbox.attr('data-filter-name');
            var attributeName = firstCheckbox.attr('data-attribute-name');
            var key = filterName || (attributeName ? attributeName.toLowerCase() : label.text().trim().toLowerCase().replace(/\s+/g, '-'));

            var labelText = label.text().trim();

            label.removeClass('mb-3 mb-4 pb-5');
            label.addClass('collapsible-filter');
            label.html('<span>' + labelText + '</span><svg class="icon icon-sm filter-chevron" style="width: 12px; height: 12px;"><use href="#icon-down"></use></svg>');

            var targetId = 'filter-content-' + key;
            var contentElements = block.children().not(label).not('.filter-content');

            if (contentElements.length > 0) {
                contentElements.wrapAll('<div id="' + targetId + '" class="filter-content"></div>');
            }

            var content = $('#' + targetId);

            if (collapsedFilters.has(key)) {
                label.addClass('collapsed');
                content.hide();
                label.find('.filter-chevron').css('transform', 'rotate(-90deg)');
            }

            // Use event delegation to avoid memory leaks
            label.off('click.collapse').on('click.collapse', function(e) {
                e.preventDefault();
                e.stopPropagation();
                toggleFilter($(this), key);
            });
        });

        updateActiveFilterIndicators();
        cslLog('[WebshopFilters] Collapsible filters initialized');
    }

    function toggleFilter(label, filterName) {
        var targetId = 'filter-content-' + filterName;
        var content = $('#' + targetId);

        if (label.hasClass('collapsed')) {
            content.slideDown(200);
            label.removeClass('collapsed');
            label.find('.filter-chevron').css('transform', 'rotate(0deg)');
            collapsedFilters.delete(filterName);
        } else {
            content.slideUp(200);
            label.addClass('collapsed');
            label.find('.filter-chevron').css('transform', 'rotate(-90deg)');
            collapsedFilters.add(filterName);
        }
    }

    function updateActiveFilterIndicators() {
        $('.filter-block').each(function() {
            var block = $(this);
            var hasChecked = block.find('input:checked').length > 0;
            block.toggleClass('has-active-filter', hasChecked);
        });
    }

    // OPTIMIZATION: Consolidated DOM operations to reduce reflows
    function applyCompactSpacing() {
        // Batch all spacing changes together
        var $filterBlocks = $('.filter-block');
        var $filterLabels = $('.filter-label');

        // Remove spacing classes in batch
        $filterBlocks.removeClass('mb-4 pb-5 my-4 py-4');
        $filterLabels.removeClass('mb-3 my-3');

        // Apply CSS in batch using addClass instead of individual .css() calls
        $filterBlocks.addClass('compact-filter-block');
        $filterLabels.addClass('compact-filter-label');

        // Title section fixes
        $('.filters-section .title-section').removeClass('mb-5').addClass('compact-title-section');
        $('.filters-section .filters-title').removeClass('mb-4');
        $('.filters-section .clear-filters').removeClass('mb-4');
    }

    function hideSearchBoxes() {
        // Hide search boxes from attribute filters
        $('.filter-block input[type="text"]').hide();
        $('input[placeholder*="Search"]').hide();
        $('input[placeholder*="Sizes"]').hide();
    }

    // Export for external use
    window.webshopFilters = {
        init: initCollapsibleFilters,
        updateVisibility: updateFilterVisibility,
        updateIndicators: updateActiveFilterIndicators
    };
})();
